<template>
    <div class="modal modal-open" id="modal-add-new-brand">
        <div class="modal-overflow">
            <div class="modal-window">
                <button class="btn btn-modal-close" @click="handleClose">
                    <i class="icon icon-cancel"></i>
                </button>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--text">
                                <label for="name"
                                    >Name
                                    <span style="color: red">*</span></label
                                >
                                <input
                                    type="text"
                                    v-model="data.name"
                                    id="service"
                                />
                                <span class="error" v-if="errors.name">{{
                                    errors.name
                                }}</span>
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--tree">
                                <label for="name">Referred to TAG by</label>
                                <treeselect
                                    v-model="data.referred_by"
                                    :multiple="false"
                                    :options="partnerOptions"
                                    :clearOnSelect="true"
                                />
                                <span
                                    style="left: 0"
                                    class="error"
                                    v-if="errors.referred_by"
                                    >{{ errors.referred_by }}</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12">
                            <div class="btn-wrap flex jus-c--center">
                                <button
                                    @click="handleAdd"
                                    type="button"
                                    class="btn"
                                >
                                    Add
                                </button>
                                <button
                                    @click="handleClose"
                                    type="button"
                                    class="btn"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
    name: "addNewService",
    props: {
        onClose: {
            type: Function,
            required: true,
        },
        onAdd: {
            type: Function,
            required: true,
        },
        partners: {
            type: Array,
            required: true,
        },
    },
    components: {
        Treeselect,
    },
    data() {
        return {
            data: {
                name: "",
                referred_by: null,
            },
            errors: {
                name: null,
                referred_by: null,
            },
        };
    },

    computed: {
        partnerOptions() {
            console.log(this.partners);

            return this.partners.length >= 0
                ? this.partners.map((partner) => ({
                      id: partner.id,
                      label: partner.name,
                  }))
                : [];
        },
    },

    methods: {
        handleClose(e) {
            this.onClose(e);
        },

        handleAdd() {
            this.validationFields();

            if (this.errors.name) {
                return;
            }

            this.onAdd({
                name: this.data.name,
                partner_id: this.data.referred_by,
            });
        },

        validationFields() {
            if (!this.data.name) {
                this.errors.name = "Required";
            }

            // if (!this.data.referred_by) {
            //     this.errors.referred_by = "Required";
            // }
        },
    },
};
</script>
